import styled, { css } from "styled-components";

export const Input = styled.input`
  height: 35px;
  border-radius: 16px;
  border: 0;
  max-width: 320px;
  width: 100%;
  padding: 0 1rem;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
  color: ${({ theme }) => theme.colors.primary};

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }

  &:focus-visible {
    outline: 0;
  }
`;

export const Container = styled.div`
  margin-top: 1.5rem;
  background-color: ${({ theme }) => theme.colors.ultraLightGray};
  padding: 0.5rem;
`;

export const HeaderDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};

  > p {
    margin: 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  > span {
    background-color: ${({ theme }) => theme.colors.transactionPrimary};
    color: ${({ theme }) => theme.colors.white};
    padding: 0.25rem 0.5rem;
    border-radius: 50%;
    font-size: 0.75rem;
  }
`;

export const ContentAnimals = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    padding: 0 1rem;

    button {
      padding: 0.75rem 0.5rem;
      display: flex;
      justify-content: center;
      text-transform: uppercase;
      letter-spacing: 2px;
      width: 100%;
      font-size: 0.75rem;
      background-color: ${theme.colors.ultraLightGray};
      color: ${theme.colors.gray};
      border: 1px dashed ${theme.colors.black};
    }
  `}
`;

export const ContentButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  button {
    width: 180px;
  }
`;

export const ListAnimals = styled.div`
  margin-top: 0.5rem;
  max-height: 320px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const ContentBatch = styled.button`
  padding: 1rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  width: 100%;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);

  p {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 16px;
    text-align: left;
    margin-bottom: 0;

    span {
      color: ${({ theme }) => theme.colors.black};
      font-weight: 600;
    }
  }
`;

export const BoxChechedAnimals = styled.div`
  ${({ theme }) => css`
    padding: 0.5rem 1rem;
    border: 1px solid ${theme.colors.orange};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.white};
    color: ${theme.colors.primary};
    margin-top: 0.5rem;

    p {
      margin: 0;
      font-size: 1rem;
      margin-right: 0.5rem;
    }

    svg {
      color: ${theme.colors.orange};
      width: 1.5rem;
      height: 1.5rem;
    }
  `}
`;
